import { render, staticRenderFns } from "./DfrEmployeeAggregate.vue?vue&type=template&id=5bf16933&scoped=true"
import script from "./DfrEmployeeAggregate.vue?vue&type=script&lang=js"
export * from "./DfrEmployeeAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf16933",
  null
  
)

export default component.exports